module.exports = __webpack_public_path__ + "img/Revealing-the-rainbow-of-aromas.c0ffa93a.png";